import { useEffect } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

// gtag's own auto page_view (send_page_view) only fires once per full page
// load, which is wrong for a client-side-routed SPA — this reports a fresh
// page_view on every route change instead.
export function useAnalyticsPageview() {
  const location = useLocation();

  useEffect(() => {
    if (!window.gtag) return;
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title
    });
  }, [location.pathname, location.search]);
}
